import script from "./main01Chart.vue?vue&type=script&setup=true&name=BarChart&lang=js"
export * from "./main01Chart.vue?vue&type=script&setup=true&name=BarChart&lang=js"

const __exports__ = script;

export default __exports__